import { api } from './api.js';
import { getAnonymousId } from './anon.js';
import { trackEvent } from './analytics.js';

// Submit a drill result. Always saves locally; pushes to Postgres via the API.
// `result` = { score, maxScore, accuracyPct, metadata }
export async function submitDrillResult(slug, result) {
  const local = readLocal(slug);
  local.push({ ...result, ts: Date.now() });
  if (local.length > 50) local.shift();
  writeLocal(slug, local);

  try {
    const res = await api('/api/drills/results', {
      method: 'POST',
      body: JSON.stringify({
        slug,
        score: Number(result.score) || 0,
        maxScore: result.maxScore != null ? Number(result.maxScore) : null,
        accuracyPct: result.accuracyPct != null ? Number(result.accuracyPct) : null,
        metadata: result.metadata || null,
        anonymousId: getAnonymousId(),
      }),
    });
    trackEvent('drill_complete', {
      drill_slug: slug,
      score: Number(result.score) || 0,
      max_score: result.maxScore != null ? Number(result.maxScore) : null,
      accuracy: result.accuracyPct != null ? Number(result.accuracyPct) : null,
    });
    return { saved: res.ok };
  } catch (err) {
    return { saved: false, error: err.message };
  }
}

// Aggregate stats across all users for a drill (count + raw values for
// client-side percentile lookup).
export async function getDrillStats(slug) {
  try {
    const res = await fetch(`/api/drills/${encodeURIComponent(slug)}/stats`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

// Personal history for a slug (fast — pulled from localStorage).
export function getPersonalHistory(slug) {
  return readLocal(slug);
}

function key(slug) { return `mm-drill-${slug}-v1`; }
function readLocal(slug) {
  try { return JSON.parse(localStorage.getItem(key(slug)) || '[]'); } catch { return []; }
}
function writeLocal(slug, value) {
  try { localStorage.setItem(key(slug), JSON.stringify(value)); } catch { /* quota */ }
}

// Compute percentile from stats payload + your score.
export function percentile(stats, score) {
  if (!stats || !stats.values || stats.values.length === 0) return null;
  const sorted = [...stats.values].sort((a, b) => a - b);
  const at = sorted.findIndex((v) => v >= score);
  const pct = at < 0 ? 100 : Math.round(((sorted.length - at) / sorted.length) * 100);
  return pct;
}
